import { useCallback } from 'react';
import { getProfilePhoto } from 'api/services/user-service';
import { IGetUserProfilePhoto } from '@api/models/request/IGetUserProfilePhoto';
import useWorkspaceApiCall from './useWorkspaceApiCall';

export const useGetUserProfilePhoto = () => {
    const { callAPI, loading } = useWorkspaceApiCall<IGetUserProfilePhoto, Blob>(getProfilePhoto);

    const getProfilePhotoMethod = useCallback(async (userId: string) => {
        const resp = await callAPI({userId});
        return resp?.data?.size ? URL.createObjectURL(resp?.data) : undefined;
        }, [callAPI]);

    return { getUserProfilePhotoUrl: getProfilePhotoMethod, getProfilePhotoPending: loading };
};